import { Link } from '@tanstack/react-router';
import { CreatorsWordmark } from '../../shared/wordmark';
import { NAV_TEXT } from '../content';
import { DASHBOARD_PATHS } from '../tabs';

// The ixigo logo and lime "Creators" stamp (shared with the landing page's nav
// and footer), linking to dashboard Home. Heads the phone header and the
// desktop sidebar.
export function DashboardBrand({ className = '' }: { className?: string }) {
	return (
		<Link
			to={DASHBOARD_PATHS.home}
			aria-label={NAV_TEXT.homeLink}
			className={className}
		>
			<CreatorsWordmark />
		</Link>
	);
}
